// extracted by mini-css-extract-plugin
export default {"userChat":"Chats_userChat__D24jc","userChatInfo":"Chats_userChatInfo__+UgzY"};